abstract class InvoiceRemark {
    info(t: Function): React.ReactElement {
        return <></>;
    };
}

export default InvoiceRemark;
